import { createSelector } from '@ngrx/store';
import { INITIAL_RESPONDENT_LIST_UPLOAD_STATE } from '@ps/survey-utils';
import { surveyCreationFeature } from '../survey-creation.feature';
import { DEFAULT_CHILD_LAUNCH_STATE } from '../survey-creation-state.constants';
import { selectSurvey } from '../core/survey-creation-core.selectors';
import { resolveActiveChildKey } from './utils/launch-children.helper';

const { selectLaunch, selectCore } = surveyCreationFeature;

/**
 * The child currently being worked on — see `resolveActiveChildKey`. Falls
 * back to the default child so downstream selectors never have to
 * null-check a missing entry.
 */
export const selectLaunchForm = createSelector(
  selectLaunch,
  selectCore,
  (state, core) => {
    const key = resolveActiveChildKey(state, core.activeChildKey);
    return state.children[key] ?? DEFAULT_CHILD_LAUNCH_STATE;
  },
);

/** The active child's respondent-list upload UI state */
export const selectRespondentListUpload = createSelector(
  selectLaunch,
  selectCore,
  (state, core) => {
    const key = resolveActiveChildKey(state, core.activeChildKey);
    return (
      state.respondentListUploads[key] ?? INITIAL_RESPONDENT_LIST_UPLOAD_STATE
    );
  },
);

/**
 * The server-resolved URL the TEST button opens. Lives on the survey itself,
 * so saving or patching keeps it current without anything else tracking it.
 */
export const selectTestEntryLink = createSelector(
  selectSurvey,
  // `|| null` so a blank link reads as "no link" rather than opening one.
  (survey) => survey?.testPsSurveyEntryLink || null,
);

export const selectLaunchPricing = createSelector(
  selectLaunch,
  (state) => state.pricing,
);

export const selectIsLaunchPricingLoading = createSelector(
  selectLaunch,
  (state) => state.isPricingLoading,
);

export const selectIsLaunching = createSelector(
  selectLaunch,
  (state) => state.isLaunching,
);

export const selectAidaEligibility = createSelector(
  selectLaunch,
  (state) => state.aidaEligibility,
);
